import { Component } from '@angular/core';
import { ICellRendererAngularComp, ITooltipAngularComp } from 'ag-grid-angular';
import { ICellRendererParams, ITooltipParams } from 'ag-grid-community';
import { Phase, Release } from '../services/release.service';

@Component({
  selector: 'cohorts-column-view-tooltip',
  template: `
  <div class="cohorts-column-view-tooltip">
    <div *ngFor="let phase of phases">
      <span class="lx-body-bold">{{ phase.name }}: </span>
      <span class="lx-body">{{ phase.cohorts.join(', ') }} </span>
    </div>
  </div>`,
  styleUrls: ['./cohorts-column-view-tooltip.component.scss']
})

export class CohortsColumnViewToolTipComponent implements ITooltipAngularComp{

  phases: Phase[];
  constructor() { }

  agInit(params: ITooltipParams): void {
    this.phases = params.data.phases;
  }
}